import React, { memo, useEffect } from 'react';
import BookingFormStore from 'Stores/BookingFormStore';
import Cart from 'Components/Front/Cart';
import bemit from 'Functions/bemit';
import { isTrue, num } from 'Shared/utilities';
export default memo(function BookingCartWidget({
  ...props
}) {
  const disposition = BookingFormStore.useState(s => s.disposition);
  const grand_total = BookingFormStore.useState(s => s.grand_total);
  const hours_count = BookingFormStore.useState(s => num(s.hours_count, 0));
  const code_data = BookingFormStore.useState(s => s.discount_code_data);
  const services = BookingFormStore.useState(s => s.services);
  const people = BookingFormStore.useState(s => s.people);
  const start = BookingFormStore.useState(s => s.start);
  const date = BookingFormStore.useState(s => s.date);
  const b2b = BookingFormStore.useState(s => isTrue(s.b2b));
  const end = BookingFormStore.useState(s => s.end);
  return /*#__PURE__*/React.createElement("div", {
    className: bemit('o-page-part', ['cart'].concat(props['white-label-booking'] ? ['white-label-booking'] : []))
  }, /*#__PURE__*/React.createElement(Cart, {
    date: date,
    start: start,
    end: end,
    people: people,
    space: props.space,
    amount: grand_total,
    services: services,
    disposition: disposition,
    b2b: b2b,
    "discount-code": code_data,
    hours_count: hours_count
  }));
});
